import _defineProperty from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

var _SLIDE_BODY_MAP;

import TextImageSlideBody from "../components/carousel/slide-item/text-image-slide-body/TextImageSlideBody";
import TextSlideBody from "../components/carousel/slide-item/text-slide-body/TextSlideBody";
import ImageTitleBody from "../components/carousel/slide-item/image-title-body/ImageTitleBody";
import { email, secure, expert } from "@limitless/images";
var TEXT_SLIDE = "text";
export var TEXT_IMAGE_SLIDE = "text/image";
var IMAGE_TITLE_SLIDE = "image/title";
var SLIDE_BODY_MAP = (_SLIDE_BODY_MAP = {}, _defineProperty(_SLIDE_BODY_MAP, TEXT_IMAGE_SLIDE, TextImageSlideBody), _defineProperty(_SLIDE_BODY_MAP, TEXT_SLIDE, TextSlideBody), _defineProperty(_SLIDE_BODY_MAP, IMAGE_TITLE_SLIDE, ImageTitleBody), _SLIDE_BODY_MAP);
export var HIW_CARD_TYPES = [{
  label: "Headline, Image, Title",
  value: TEXT_IMAGE_SLIDE
}, {
  label: "Text Only",
  value: TEXT_SLIDE
}, {
  label: "Image, Title, Headline",
  value: IMAGE_TITLE_SLIDE
}];
export var getSlideBodyComponent = function getSlideBodyComponent(type) {
  var SlideBody = SLIDE_BODY_MAP[type]; //if the type is missing or not set, use text image slide

  SlideBody = SlideBody ? SlideBody : SLIDE_BODY_MAP[TEXT_IMAGE_SLIDE];
  return SlideBody;
};
export var getDefaultHIWSlides = function getDefaultHIWSlides() {
  return [{
    id: 1,
    title: "How it Works",
    imgSrc: expert,
    headline: "Ambassadors are customers like you. They love helping people, are passionate about products and are quick to share useful information",
    buttonText: "Get Started",
    primaryColour: "#0050FF",
    contrastColour: "white",
    type: TEXT_IMAGE_SLIDE
  }, {
    id: 2,
    title: "How it Works",
    imgSrc: secure,
    headline: "They are NOT employees so please do not share any personal or account information with your Ambassadors ",
    buttonText: "Get Started",
    primaryColour: "#EB8C34",
    contrastColour: "white",
    type: TEXT_IMAGE_SLIDE
  }, {
    id: 3,
    title: "How it Works",
    imgSrc: email,
    headline: "Provide your email address and receive instant notifications when Ambassadors respond",
    buttonText: "Get Started",
    primaryColour: "#663FC0",
    contrastColour: "white",
    type: TEXT_IMAGE_SLIDE
  }];
};